module.exports = __webpack_public_path__ + "img/UAV_data-1.5b25b587.jpg";